import React from 'react';
import cn from 'classnames';
import Card from '../../Card';
import { Icon } from 'antd';
import { formatPhoneNumber } from '../../../helpers/formatPhoneNumber';
import getName from '../../../helpers/getName';
import styles from './RequestTenantCard.module.scss';

const RequestTenantCard = ({ request = {}, className }) => {
  const phones =
    request.contactPhones
      ?.split(', ')
      ?.map((phoneNumber) =>
        formatPhoneNumber({
          phoneNumber,
          format: '(xxx) xxx-xx-xx',
          placeholder: 'x',
        })
      )
      ?.join(', ') || '';

  return (
    <Card className={cn(styles.root, className)}>
      {(request.clientName || phones) && (
        <div className={styles.block}>
          <h3 className={styles.blockTitle}>Заявитель</h3>
          {request.clientName && (
            <p className={styles.blockParagraph}>
              <Icon type="user" />
              <span>
                {request.clientName}
                {request.contactType === 'Owner' && (
                  <>
                    {' '}
                    <span className={styles.accent}>(Собственник)</span>
                  </>
                )}
              </span>
            </p>
          )}
          {phones && (
            <p className={styles.blockParagraph}>
              <Icon type="phone" />
              <span>{phones}</span>
            </p>
          )}
        </div>
      )}

      {request.createUser && (
        <div className={styles.block}>
          <h3 className={styles.blockTitle}>Создатель</h3>
          <p className={styles.blockParagraph}>
            <span>
              {getName(request.createUser)}
              {request.createUser.specialityName && (
                <>
                  {' '}
                  <span className={styles.accent}>
                    ({request.createUser.specialityName})
                  </span>
                </>
              )}
            </span>
          </p>
        </div>
      )}

      {request.description && (
        <div className={styles.block}>
          <h3 className={styles.blockTitle}>Описание</h3>
          <p className={styles.blockParagraph}>{request.description}</p>
        </div>
      )}
    </Card>
  );
};

export default RequestTenantCard;
